module.exports = __webpack_public_path__ + "img/314.fcc96758.jpg";